import { styled } from '@mui/material';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  width: 100%;
  flex: 1;
  height: 100%;

  & > svg {
    width: 120px;
    height: 120px;
    flex-shrink: 0;
  }
`;

export const Text = styled('p')`
  color: #807d93;
  text-align: center;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
`;
